import React from "react";
import UserService from "../utils/userService";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Button, Col } from "react-bootstrap";
import {
  SCHOOL_DATA_CONSTANTS,
  DRAWER_CONSTANTS,
} from "../constants/schoolData";
import { Checkbox } from "antd";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { ALLOWED_ROLES } from "../constants/Map";

const DrawerComponent = ({
  isOpen,
  onClose,
  handleLogOut,
  onClickMenuItem,
  isMobileDevice,
  menuItemDisabled,
  tableColumns,
  handleCheckboxAction,
}) => {
  const user = UserService.getUserData();
  const disableCheckbox = (dataIndex) => {
    return dataIndex === "name" ||
      dataIndex === "role" ||
      dataIndex === "teacherMobile"
      ? true
      : false;
  };

  const getTableColumnFilter = () => {
    return tableColumns?.map((col, i) => {
      return col.title ? (
        <MenuItem
          key={`column-${col.dataIndex}-${i + 1}`}
          className="table-column-menu-item"
        >
          <div className="dflex">
            <Checkbox
              checked={col?.isSelected}
              className="mr-2"
              disabled={disableCheckbox(col?.dataIndex)}
              onClick={() =>
                handleCheckboxAction({ ...col, isSelected: !col?.isSelected })
              }
            />
            <div>{col?.title}</div>
          </div>
        </MenuItem>
      ) : (
        <div key={`column-${col.dataIndex}-${i + 1}`} />
      );
    });
  };

  return (
    <Sidebar
      className="sidebar-container"
      onBackdropClick={() => onClose(DRAWER_CONSTANTS.drawerState)}
      toggled={isOpen}
      breakPoint="all"
    >
      {isMobileDevice && (
        <div className="user-info-container">
          <div>
            Welcome, <strong className="mr-2">{`${user.name}`}</strong>
          </div>
          <div className="dflex">
            <div className="role-badge">{user.rolename}</div>
          </div>
        </div>
      )}

      <Menu className="drawer-menu-container">
        <MenuItem
          className="menu-item-container table-column-item-container"
          label="Home"
          component={<Link to="/" />}
          icon={<FontAwesomeIcon icon="home" size="2x" />}
        >
          Home
        </MenuItem>
        <SubMenu
          label="Reports"
          disabled={menuItemDisabled}
          className="menu-item-container"
          icon={<FontAwesomeIcon icon="chart-simple" size="2x" />}
        >
          <MenuItem
            onClick={() =>
              onClickMenuItem(
                DRAWER_CONSTANTS.menuItemState,
                DRAWER_CONSTANTS.oneClickMenuItem
              )
            }
          >
            Users who did 1-click
          </MenuItem>
          <MenuItem
            onClick={() =>
              onClickMenuItem(
                DRAWER_CONSTANTS.menuItemState,
                DRAWER_CONSTANTS.badFirmwareMenuItem
              )
            }
          >
            TA - Bad Lenovo firmwares
          </MenuItem>
        </SubMenu>
        <SubMenu
          label="Table Columns"
          disabled={menuItemDisabled}
          className="menu-item-container"
          icon={<FontAwesomeIcon icon="table-columns" size="2x" />}
        >
          <div className="table-column-item-container">
            {getTableColumnFilter()}
          </div>
        </SubMenu>

        <SubMenu
          label="OPP"
          component={<Link to="/opp" />}
          disabled={menuItemDisabled}
          className="menu-item-container"
          defaultOpen
          // rootStyles={{ '.ps-menu-button': { pointerEvents: 'none' } }}
          icon={<FontAwesomeIcon icon="warehouse" size="2x" />}
        >
          <MenuItem
            component={<Link to="/opp/create" />}
            onClick={() =>
              onClickMenuItem(
                DRAWER_CONSTANTS.createNewOrder
              )
            }
          >
            Create New Order
          </MenuItem>
          <MenuItem
            component={<Link to="/opp/orders" />}
            onClick={() =>
              onClickMenuItem(
                DRAWER_CONSTANTS.createNewOrder,
              )
            }
          >
            View existing orders
          </MenuItem>
        </SubMenu>
        {/* <MenuItem
          className="menu-item-container table-column-item-container"
          label="OPP"
          component={<Link to="/opp" />}
          icon={<FontAwesomeIcon icon="warehouse" size="2x" />}
        >
          OPP
        </MenuItem> */}
        <MenuItem
          className="menu-item-container table-column-item-container"
          label="OPP"
          component={<Link to="/triggerOneClick" />}
          icon={<FontAwesomeIcon icon="warehouse" size="2x" />}
        >
          Trigger 1-click
        </MenuItem>
        {ALLOWED_ROLES.includes(user.rolecode) && <MenuItem
          className="menu-item-container table-column-item-container"
          label="Map View"
          component={<Link to="/schooldata/map" />}
          icon={<FontAwesomeIcon icon={faMap} size="2x" />}
        >

          Map View
        </MenuItem>}
      </Menu>

      <div className="drawer-footer-container">
        {isMobileDevice && (
          <Button
            className="popover-logout-btn"
            style={{ marginLeft: "10px" }}
            onClick={handleLogOut}
          >
            {SCHOOL_DATA_CONSTANTS.btns.logout}
          </Button>
        )}
        <div className="version-container">
          Version: <b> {process.env.REACT_APP_VERSION}</b>
        </div>
      </div>
    </Sidebar>
  );
};

export default DrawerComponent;
